import { styled } from "styled-components";

import { typeScale } from "lib/themeUtils";

export const Column = styled.div`
  ${typeScale.sm};
  color: ${(props) => props.theme.colours.bodyLight};
`;
